export class ContractFilterType {
  constructor(
    public name: string,
    public selected: boolean = false,
    public display = true
  ) {}
}

export class ContractFilterGroupType {
  constructor(
    public name: string,
    public selected: boolean = false,
    public batch: ContractFilterType[] = []
  ) {}
}
